import { Effect } from "../Materials/effect";
import "./ShadersInclude/helperFunctions";
var name = 'rgbdEncodePixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\n#include<helperFunctions>\nvoid main(void)\n{\ngl_FragColor=toRGBD(texture2D(textureSampler,vUV).rgb);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var rgbdEncodePixelShader = { name: name, shader: shader };
//# sourceMappingURL=rgbdEncode.fragment.js.map